module.exports = __webpack_public_path__ + "media/images/static/top/urban/right-de99bef786ef25ed8bd381ce0a00881a.png";